import type { CurrencyCode } from '../../../types/api.types'

// ── Currency options ──

export const CURRENCY_OPTIONS: { code: CurrencyCode; label: string; symbol: string }[] = [
  { code: 'PKR', label: 'PKR - Pakistani Rupee', symbol: 'Rs' },
  { code: 'AED', label: 'AED - UAE Dirham', symbol: 'AED' },
  { code: 'USD', label: 'USD - US Dollar', symbol: '$' },
  { code: 'EUR', label: 'EUR - Euro', symbol: '€' },
  { code: 'GBP', label: 'GBP - British Pound', symbol: '£' },
  { code: 'SAR', label: 'SAR - Saudi Riyal', symbol: 'SAR' },
  { code: 'INR', label: 'INR - Indian Rupee', symbol: '₹' },
  { code: 'QAR', label: 'QAR - Qatari Riyal', symbol: 'QAR' },
  { code: 'KWD', label: 'KWD - Kuwaiti Dinar', symbol: 'KWD' },
  { code: 'BHD', label: 'BHD - Bahraini Dinar', symbol: 'BHD' },
  { code: 'OMR', label: 'OMR - Omani Rial', symbol: 'OMR' },
  { code: 'EGP', label: 'EGP - Egyptian Pound', symbol: 'EGP' },
  { code: 'TRY', label: 'TRY - Turkish Lira', symbol: '₺' },
  { code: 'MYR', label: 'MYR - Malaysian Ringgit', symbol: 'RM' },
  { code: 'SGD', label: 'SGD - Singapore Dollar', symbol: 'S$' },
  { code: 'CAD', label: 'CAD - Canadian Dollar', symbol: 'C$' },
  { code: 'AUD', label: 'AUD - Australian Dollar', symbol: 'A$' },
  { code: 'BDT', label: 'BDT - Bangladeshi Taka', symbol: '৳' },
]

// ── Tab configuration ──

export type AdminTab = 'users' | 'properties' | 'devices' | 'teams' | 'tables' | 'printers' | 'qr'

// ── BLE provisioning constants ──

export const PROVISIONING_SERVICE_UUID = '4fafc201-1fb5-459e-8fcc-c5c9c331914b'
export const CHAR_PROVISION_WRITE_UUID = 'beb5483e-36e1-4688-b7f5-ea07361b26a8'
export const CHAR_STATUS_UUID = 'beb5483e-36e1-4688-b7f5-ea07361b26a9'

export const QUICKCOMM_SETUP_LAST_SSID_KEY = 'quickcomm_last_wifi_ssid'
export const QUICKCOMM_SETUP_LAST_DEVICE_NAME_KEY = 'quickcomm_last_device_name'
// The printer used to be cached here too. It lives on the property now, which is
// what makes it survive a different admin on a different laptop.
export const QUICKCOMM_SETUP_LAST_LOCAL_IP_KEY = 'quickcomm_last_local_ip'
export const QUICKCOMM_SETUP_LAST_LOCAL_PORT_KEY = 'quickcomm_last_local_port'

// Raw ESC/POS port — the default on every network thermal printer we ship with.
export const DEFAULT_PRINTER_PORT = 9100
